import React from 'react';

import { Container } from '@material-ui/core';
import RiskScoreCard from './RiskScoreCard';
import moment from 'moment';
import { Format } from 'app/app.constants';

const RiskMatrixHistoryDrawerContent = ({ riskTrendScores }) => {
  const sortedRiskTrends = [...riskTrendScores].sort(
    (a, b) => new Date(b.totalScoreDate) - new Date(a.totalScoreDate),
  );

  return (
    <>
      <Container>
        {sortedRiskTrends.map((risk, index) => {
          const date = moment(risk.totalScoreDate).format(
            Format.date_dayfirst_withtime,
          );
          let riskScore = risk.totalScoreCalculation.toFixed(3);
          const prevRisk =
            index < sortedRiskTrends.length
              ? sortedRiskTrends[index + 1]
              : null;

          const prevRiskScore = prevRisk
            ? prevRisk.totalScoreCalculation.toFixed(3)
            : null;

          if (riskScore && risk.integrityTitle)
            return (
              <RiskScoreCard
                score={riskScore}
                prevRiskScore={prevRiskScore}
                date={date}
                risk={risk}
              />
            );

          return null;
        })}
      </Container>
    </>
  );
};

export default RiskMatrixHistoryDrawerContent;
